var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WorkIcon',_vm._b({},'WorkIcon',_vm.$props,false),[_vm._v(" "+_vm._s('$wCircle')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }